import api from '@/utils/api';

/**
 * get user
 *
 * @param {string} userRoleId - The user role get
 * @returns {Promise} The promise object of the api call
 */
const getUserRoleApi = (userRoleId) => api.get(`user-role/${userRoleId}`);
export default getUserRoleApi;
